


























import { Vue, Component, Watch } from 'vue-property-decorator'
import BotaoDeDrawer from '@/components/ui/BotaoDeDrawer.vue'
import PluginModule from '@/store/vuex/aplicacao/PluginStore'
import IconesDaToolbarPadroes from '@/components/layout/IconesDaToolbarPadroes.vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import type { Route } from 'vue-router'
import type { EventName } from '@/models'
import { estadoDaLojaSendoEditada } from '@/shareds/loja-shareds'

@Component({
	components: {
		BotaoDeDrawer,
		IconesDaToolbarPadroes,
	},
})
export default class ToolbarDeEdicaoDeLoja extends Vue {
	botoesCustomizados: BotaoCustomizado[] = []

	created() {
		PluginModule.on('adicionar-botao-customizado', this.adicionarBotaoCustomizado)
	}

	get nomeLoja(): string {
		return estadoDaLojaSendoEditada.nome || ''
	}

	executarEventoDoBotaoCustomizado(botao: BotaoCustomizado) {
		PluginModule.emit(
			botao.nomeDoEvento as EventName,
			{ token: UserLoginStore.token },
		)
	}

	adicionarBotaoCustomizado(botao: BotaoCustomizado) {
		const indice = this.botoesCustomizados.findIndex(
			botaoCustomizado => botaoCustomizado.id === botao.id,
		)
		indice === -1
			? this.botoesCustomizados.push(botao)
			: this.botoesCustomizados.splice(indice, 1, botao)
	}

	@Watch('$route', { immediate: true, deep: true })
	async onChangeRoute(route: Route) {

		PluginModule.emit('alternar-rota', {
			name: route.name,
		})
		this.botoesCustomizados = this.botoesCustomizados.filter(
			botao => !botao.rotaParaExibicao || botao.rotaParaExibicao === route.name,
		)
	}
}

type BotaoCustomizado = {
	id: string
	texto: string
	nomeDoEvento: string
	icone?: string
	rotaParaExibicao?: string
}
